import axios from "../axios-instance";

/**
 * Thunk — calls the backend impersonation endpoint and returns the token data.
 * The caller is responsible for calling startImpersonation() with the result.
 *
 * @param {number} userId - ID of the user to impersonate
 * @returns {Promise<{ access_token, jwt_custom_claims }>}
 */
export const impersonateUser = (userId) => async () => {
  const res = await axios.post(`super-admin/impersonate/${userId}`);
  return res.data.data;
};
